import { render, staticRenderFns } from "./manage-categories.modal.vue?vue&type=template&id=bceb7dc4&scoped=true&"
import script from "./manage-categories.modal.vue?vue&type=script&lang=js&"
export * from "./manage-categories.modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-categories.modal.vue?vue&type=style&index=0&id=bceb7dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb7dc4",
  null
  
)

export default component.exports